var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnreaded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2605 4.33H3.73876L7.20128 6.85335C7.39625 6.99544 7.68293 7.085 7.99962 7.085C8.31631 7.085 8.60299 6.99544 8.79796 6.85335L12.2605 4.33ZM2.33181 4.95038C2.33061 4.96676 2.33 4.98331 2.33 5V11C2.33 11.37 2.62997 11.67 3 11.67H13C13.37 11.67 13.67 11.37 13.67 11V5C13.67 4.98313 13.6694 4.96641 13.6682 4.94985L9.58128 7.92821C9.11903 8.26508 8.54432 8.415 7.99962 8.415C7.45492 8.415 6.88021 8.26508 6.41796 7.92821L2.33181 4.95038ZM1 5C1 3.89543 1.89543 3 3 3H13C14.1046 3 15 3.89543 15 5V11C15 12.1046 14.1046 13 13 13H3C1.89543 13 1 12.1046 1 11V5Z",
    fill: "#37A4F2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnreaded);
export default __webpack_public_path__ + "static/media/unreaded.01b8997a792cedd990051f5fad9d5e7f.svg";
export { ForwardRef as ReactComponent };